import { useCallback, useMemo } from "react";
import { TOOLBAR_MODE } from "@acadia-ui/toolbar";
import MultiplierModal from "../../Modals/MultiplierModal";
import Tooltip, { TOOLTIP_POSITION } from "@acadia-ui/tooltip";
import Button, { BUTTON_DISPLAY, BUTTON_SIZE } from "@acadia-ui/button";
import Modal from "@acadia-ui/modal";
import { retryAtInterval } from "./retryAtInterval";
import { showToast, ToastNotification, TOAST_TYPE } from "@acadia-ui/toast";
import { draftHLISelected } from "../../../Helpers/ActionHelpers";

export default function useMultiply({ config, renderedData, selectedRows, setRenderedData, dataTableApi }) {
	const handleMultiply = (dataWithMultipliedRows) => {
		showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.SUCCESS} message="Placements multiplied successfully." timed={10000} />);
		dataTableApi.current.dataProvider.update(dataWithMultipliedRows);
		setTimeout(() => {
			dataTableApi.current.refreshDisabledCellStates?.();
		}, 100);
		// setRenderedData(dataWithMultipliedRows);
		retryAtInterval(
			() => {
				dataTableApi?.current?.toolbarApi?.current?.changeActiveMode?.(TOOLBAR_MODE.EDIT);
			},
			() => dataTableApi?.current?.toolbarApi?.current?.activeMode === TOOLBAR_MODE.EDIT
		);
	};

	const Trigger = useCallback(() => {
		const disabled =
			dataTableApi?.current?.rowSelectionManager?.tree?.children?.loadedNodes?.filter(({ selectionState }) => selectionState === true)?.length !== 1 ||
			draftHLISelected(dataTableApi);
		return (
			<Tooltip key="action-multiply" title="Multiply Placements" position={TOOLTIP_POSITION.BOTTOM_START}>
				<Button
					size={BUTTON_SIZE.SMALL}
					display={BUTTON_DISPLAY.ICON_BORDERED}
					icon="icon-copy-clipboard"
					onClick={() => Modal.show("Placement_multiplier")}
					disabled={disabled}
					data-tracking-id-alt="open-multiply-placements-modal"
				>
					Placement Multiplier
				</Button>
			</Tooltip>
		);
	}, [dataTableApi]);

	const DisplayedComponent = useCallback(
		() => (
			<MultiplierModal
				data={selectedRows[0]}
				handleMultiply={handleMultiply}
				allRows={dataTableApi?.current?.dataProvider?.data || renderedData}
				config={config}
				type="Placement"
				hierarchyLevel="Placement"
				name="Placement"
			/>
		),
		[handleMultiply, config, renderedData, selectedRows, dataTableApi]
	);

	return useMemo(() => [Trigger, DisplayedComponent], [Trigger, DisplayedComponent]);
}
